import React from "react";
import { Link } from "react-router-dom";

// Will aggregate posts on main page
const Posts = ({ posts, deletePost, isAuthenticated }) => (
  <article className="posts container">
    <img
      src={require("./media/colombo.jpg")}
      alt="Colombo holding a cigar scratching his head"
    />
    <ul>
      {/* Will display no post message if there are not any */}
      {posts.length < 1 && <li key="empty">No posts yet!</li>}

      {/* Display Posts with title links */}
      {posts.map((post) => (
        <li key={post.id}>
          <h2>
            <Link to={`/post/${post.slug}`}>{post.title}</Link>
          </h2>
          {isAuthenticated && (
            // Edit post link
            <p>
              <Link to={`/edit/${post.slug}`}>Edit</Link>
              {" | "}
              <button
                className="linkLike"
                onClick={(e) => {
                  e.preventDefault();
                  deletePost(post);
                }}
              >
                Delete
              </button>
            </p>
          )}
        </li>
      ))}
    </ul>
  </article>
);

export default Posts;
